import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { loadConfig } from './services/config';

const root = ReactDOM.createRoot(document.getElementById('root'));

// Load appsettings.json (API URL etc.) before rendering so we can change it without rebuild
loadConfig().then(() => {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}); 